import { constants } from './constants';

type SymbolObj<T extends string = string> = Record<T, symbol>;
const makeSymbolObj = <T extends string>(names: readonly T[]) =>
  names.reduce((acc, name) => {
    acc[name] = Symbol.for(name);
    return acc;
  }, {} as SymbolObj<T>);

const KNOWN_INTERFACES = [
  // V1
  'BoundedEventStore',
  'PersistenceBackend',
  'Transport',
  'WithTimeout',
  'TimestampFactory',
  'PerfTimestampFactory',
  'ClientSideRequestProcessor',
  'V1ClientSDK',
  'NativeFunctionsProvider',
  // V2
  'V2Transport',
  'V2ClientSDK',
  'getTimezone',
  'V2ClientSideRequestProcessor',
  'V2ClientStateFactory',
  'V2ClientFeatureState',
  'WindowProvider',
  'ClientEventDB',
  'ClientEventDBProvider',
  'random',
  'DefaultFeatureStates',
  'ConditionaExpressionProvider',
] as const;

export const DI_TYPES = makeSymbolObj(KNOWN_INTERFACES);

export const DI_CONSTANTS = makeSymbolObj(Object.keys(constants));
